import React, { Component } from 'react';
import styled from 'styled-components';
import { t } from 'src/utils/translate';

import BannerImage from 'components/BannerImage';
import Page from 'components/Page';
import ScrollAnimation from 'components/ScrollAnimation';
import ContentBlock from 'components/ContentBlock';
import ColumnTwo from 'components/ColumnTwo';
import Slider from 'components/Slider';

const slides = [
  {
    image: require('src/assets/images/developer/gallery/bining-tower.jpg'),
    caption: 'Bining Tower | Vancouver',
  },
  {
    image: require('src/assets/images/developer/gallery/capitol.jpg'),
    caption: 'Capitol | Downtown Vancouver',
  },
  {
    image: require('src/assets/images/developer/gallery/hudson.jpg'),
    caption: 'Hudson | Vancouver',
  },
  {
    image: require('src/assets/images/developer/gallery/one-wall.jpg'),
    caption: 'One Wall | Downtown Vancouver',
  },
  {
    image: require('src/assets/images/developer/gallery/shannon-wall.jpg'),
    caption: 'Shannon Wall Kerrisdale | Vancouver',
  },
  {
    image: require('src/assets/images/developer/gallery/shannon-wall-2.jpg'),
    caption: 'Shannon Wall Kerrisdale | Vancouver',
  },
  {
    image: require('src/assets/images/developer/gallery/wall-centre.jpg'),
    caption: 'Wall Centre False Creek | Vancouver',
  },
  {
    image: require('src/assets/images/developer/gallery/wall-centre-2.jpg'),
    caption: 'Wall Centre False Creek | Vancouver',
  },
  {
    image: require('src/assets/images/developer/gallery/wall-centre-3.jpg'),
    caption: 'Wall Centre Park | Vancouver',
  },
  {
    image: require('src/assets/images/developer/gallery/wall-centre-4.jpg'),
    caption: 'Wall Centre Richmond | Richmond',
  },
];

class Developer extends Component {
  state = {};
  render() {
    return (
      <Page
        background={require('src/assets/images/developer/banner.jpg')}
        banner={<BannerImage />}
      >
        <Root>
          <ScrollAnimation>
            <ColumnTwo
              left={
                <ContentBlock
                  title={
                    <span>
                      {t('developer.title')}
                    </span>
                  }
                  subtitle={t('developer.subtitle')}
                >
                  <LogoWallFinancial
                    src={require('src/assets/images/developer/wallfinancial-logo.svg')}
                    alt=""
                    style={{width: '100px'}}
                  />
                  {t('developer.copy')}
                </ContentBlock>
              }
              right={<Slider slides={slides} />}
            />
          </ScrollAnimation>
        </Root>
      </Page>
    );
  }
}

const Root = styled.div``;

const LogoWallFinancial = styled.img`
  margin-bottom: 35px;
`;

export default Developer;



// WEBPACK FOOTER //
// ./src/pages/Developer/Developer.js